export function checkValidForPlusLoadQuantity(value: string) {
  if (value === '' || value === '.') {
    return true
  }
  if (!value.includes('.')) {
    if (value.length === 1) {
      return true
    }
    return false
  }
  const splitted = value.split('.')
  if (splitted.length > 2) {
    return false
  }

  return splitted.every((splittedString) => splittedString.length <= 1)
}
